// External libraries
import { useState } from 'react'
// Components
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '@/components/ui/dialog'
import { MessageSquareText } from 'lucide-react'
import WelcomeMessagesForm from '@/components/ManageCourses/welcome-message/WelcomeMessagesForm'

export default function WelcomeMessagesDialog({
  courseName,
}: Readonly<{
  courseName: string
}>) {
  const [isOpen, setIsOpen] = useState(false)

  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogTrigger asChild>
        <MessageSquareText className="w-5 h-5" />
      </DialogTrigger>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Welcome Messages</DialogTitle>
        </DialogHeader>
        <DialogDescription className="pb-2">View or Edit {courseName} welcome messages</DialogDescription>
        <section>
          <WelcomeMessagesForm courseName={courseName} closeDialog={() => setIsOpen(false)} />
        </section>
      </DialogContent>
    </Dialog>
  )
}
